import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, ElementRef, EventEmitter, ViewContainerRef } from '@angular/core';
import Popper from 'popper.js';
import { BaseComponent } from '../../base.component';
var ColorPickerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ColorPickerComponent, _super);
    function ColorPickerComponent(_vcr, changeDetectorRef) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.changeDetectorRef = changeDetectorRef;
        _this._color = 'red';
        _this.colorChange = new EventEmitter();
        _this.openPicker = new EventEmitter();
        _this._showColorPicker = false;
        _this.siblingColorPickers = [];
        _this.outsideClickHandler = function () {
            _this.showColorPicker = false;
        };
        _this.insideClickHandler = function (e) {
            e.stopPropagation();
        };
        return _this;
    }
    Object.defineProperty(ColorPickerComponent.prototype, "includeGoogleAnalytics", {
        get: function () { return false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColorPickerComponent.prototype, "color", {
        get: function () { return this._color; },
        set: function (val) {
            if (this._color !== val) {
                this._color = val;
                this.colorChange.emit(this._color);
                this.changeDetectorRef.detectChanges();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColorPickerComponent.prototype, "showColorPicker", {
        get: function () { return this._showColorPicker; },
        set: function (val) {
            if (val !== this._showColorPicker) {
                this._showColorPicker = val;
                if (this._showColorPicker) {
                    this.onShow();
                }
                else {
                    this.onHide();
                }
                if (!this.changeDetectorRef.destroyed) {
                    this.changeDetectorRef.detectChanges();
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    ColorPickerComponent.prototype.ngAfterViewInit = function () {
        this.colorPickerPopperRef = new Popper(this.colorPickerToggleRef.nativeElement, this.colorPickerContainerRef.nativeElement, {
            placement: 'bottom-end',
            positionFixed: true
        });
    };
    ColorPickerComponent.prototype.pickerColorChanged = function (e) {
        var rgb = e.color.rgb;
        this.color = "rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", " + rgb.a + ")";
    };
    ColorPickerComponent.prototype.onShow = function () {
        this.hideSiblings();
        this.colorPickerPopperRef.update();
        window.addEventListener('mousedown', this.outsideClickHandler);
        window.addEventListener('dragstart', this.outsideClickHandler);
        this.colorPickerContainerRef.nativeElement.addEventListener('mousedown', this.insideClickHandler);
        this.openPicker.emit('opened');
    };
    ColorPickerComponent.prototype.onHide = function () {
        window.removeEventListener('mousedown', this.outsideClickHandler);
        window.removeEventListener('dragstart', this.outsideClickHandler);
        this.colorPickerContainerRef.nativeElement.removeEventListener('mousedown', this.insideClickHandler);
    };
    ColorPickerComponent.prototype.hideSiblings = function () {
        var e_1, _a;
        try {
            for (var _b = tslib_1.__values(this.siblingColorPickers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var sibling = _c.value;
                sibling.showColorPicker = false;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    return ColorPickerComponent;
}(BaseComponent));
export { ColorPickerComponent };
